import { createFileRoute } from "@tanstack/react-router";
import { AdminStaffView } from "@/components/admin/AdminStaffView";

export const Route = createFileRoute("/_authenticated/admin/staff")({
  head: () => ({ meta: [{ title: "Staff — Admin" }] }),
  component: AdminStaffPage,
});

function AdminStaffPage() {
  return <AdminStaffView />;
}
